import React, { useMemo, useState } from "react";
import { APISD } from "../../../../../../config/apisd";

import Modal from "react-bootstrap/Modal";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";


const safeValue = (value) => {
  if (value === null || value === undefined) return "";
  return String(value);
};

export default function PindahKelasModal({
  onHide,
  GetResponseData,
  dataUpdate,
  classes = [],
  show = true,
}) {
  const token = localStorage.getItem("token");
  const userId = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const currentClassId = safeValue(dataUpdate?.ysb_kelas_id);
  const [kelasTujuan, setKelasTujuan] = useState("");
  const [saving, setSaving] = useState(false);

  // Kelas tujuan hanya boleh berasal dari sekolah + tingkatan yang sama.
  // Kelas siswa saat ini tidak ditampilkan agar user tidak memilih kelas yang sama.
  const availableClasses = useMemo(() => {
    return (Array.isArray(classes) ? classes : [])
      .filter((item) => {
        const sameGrade =
          !dataUpdate?.ysb_grade_level_id ||
          safeValue(item?.ysb_grade_level_id) ===
            safeValue(dataUpdate?.ysb_grade_level_id);

        const sameSchool =
          !dataUpdate?.ysb_school_id ||
          safeValue(item?.ysb_school_id) === safeValue(dataUpdate?.ysb_school_id) ||
          safeValue(item?.school_code) === safeValue(dataUpdate?.ysb_school_id);

        return sameGrade && sameSchool && safeValue(item?.id) !== currentClassId;
      })
      .sort((a, b) =>
        safeValue(a?.name_kelas).localeCompare(safeValue(b?.name_kelas), "id", {
          numeric: true,
          sensitivity: "base",
        })
      );
  }, [classes, dataUpdate, currentClassId]);

  const save = async (event) => {
    event.preventDefault();

    if (saving || !kelasTujuan) return;

    if (!dataUpdate?.ysb_student_id) {
      swal({
        title: "Gagal",
        text: "ID siswa tidak ditemukan.",
        icon: "error",
      });
      return;
    }

    if (!userId) {
      swal({
        title: "Gagal",
        text: "ID pengguna login tidak ditemukan.",
        icon: "error",
      });
      return;
    }

    setSaving(true);

    try {
      // Payload mengikuti SwitchStudent.js:
      // data tanpa suffix = kelas lama, data *_switch = kelas tujuan.
      const payload = {
        ysb_academic_year_id: dataUpdate?.ysb_academic_year_id,
        ysb_semester_id: dataUpdate?.ysb_semester_id,
        ysb_branch_id: dataUpdate?.ysb_branch_id,
        ysb_school_id: dataUpdate?.ysb_school_id,
        ysb_grade_level_id: dataUpdate?.ysb_grade_level_id,
        ysb_kelas_id: dataUpdate?.ysb_kelas_id,
        ysb_student_id: dataUpdate?.ysb_student_id,

        // Pindah kelas pada tahun ajaran, semester, cabang, sekolah, dan tingkatan yang sama.
        ysb_academic_year_id_switch: dataUpdate?.ysb_academic_year_id,
        ysb_semester_id_switch: dataUpdate?.ysb_semester_id,
        ysb_branch_id_switch: dataUpdate?.ysb_branch_id,
        ysb_school_id_switch: dataUpdate?.ysb_school_id,
        ysb_grade_level_id_switch: dataUpdate?.ysb_grade_level_id,
        ysb_kelas_id_switch: kelasTujuan,

        user_id: userId,
      };

      const response = await APISD.post(
        "/api/student-rombels/switch-student",
        payload,
        {
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // if (response?.status === 200) {
      //   swal({
      //     title: "Berhasil",
      //     text: response?.data?.message || "Siswa berhasil dipindahkan",
      //     icon: "success",
      //     timer: 2500,
      //   });

      //   if (GetResponseData) await GetResponseData();
      //   onHide();
      // }
      if (response?.status === 200 || response?.status === 201) {
        ToastSuccess.fire({
          icon: "success",
          title:  "Data berhasil dipindahkan",
        });

        await GetResponseData();
        onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal memindahkan siswa",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="pindah-kelas-title"
    >
      <div className="sims-modal-header">
        <div>
          <h5 id="pindah-kelas-title" className="sims-modal-title">
            Pindah Kelas
          </h5>
        </div>
        <button
          type="button"
          className="sims-modal-close"
          onClick={onHide}
          disabled={saving}
          aria-label="Tutup modal"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <form onSubmit={save}>
        <div className="sims-modal-body">
          <div className="sims-form-grid">
            <div className="sims-form-group">
              <label className="sims-form-label">Nama Siswa</label>
              <input
                className="sims-form-select"
                value={dataUpdate?.name_student || dataUpdate?.nama_siswa || "-"}
                disabled
                readOnly
              />
            </div>

            <div className="sims-form-group">
              <label className="sims-form-label">Sekolah</label>
              <input
                className="sims-form-select"
                value={dataUpdate?.name_school || "-"}
                disabled
                readOnly
              />
            </div>

            <div className="sims-form-group">
              <label className="sims-form-label">Tingkatan Saat Ini</label>
              <input
                className="sims-form-select"
                value={dataUpdate?.name_level || "-"}
                disabled
                readOnly
              />
            </div>

            <div className="sims-form-group">
              <label className="sims-form-label">Kelas Saat Ini</label>
              <input
                className="sims-form-select"
                value={dataUpdate?.name_kelas || "-"}
                disabled
                readOnly
              />
            </div>
          </div>

          <div className="sims-form-grid">
            <div className="sims-form-group">
              <label className="sims-form-label" htmlFor="pindah-tingkatan">
                Tingkatan <span>*</span>
              </label>
              <select
                id="pindah-tingkatan"
                name="ysb_grade_level_id"
                className="sims-form-select"
                value={safeValue(dataUpdate?.ysb_grade_level_id)}
                disabled
              >
                <option value={safeValue(dataUpdate?.ysb_grade_level_id)}>
                  {dataUpdate?.name_level || "Tingkatan Saat Ini"}
                </option>
              </select>
            </div>

            <div className="sims-form-group">
              <label className="sims-form-label" htmlFor="pindah-kelas">
                Nama Kelas <span>*</span>
              </label>
              <select
                id="pindah-kelas"
                name="ysb_kelas_id_switch"
                className="sims-form-select"
                value={kelasTujuan}
                disabled={saving}
                required
                onChange={(event) => setKelasTujuan(event.target.value)}
              >
                <option value="">Pilih Kelas</option>
                {availableClasses.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name_kelas}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {availableClasses.length === 0 && (
            <div className="notification is-info is-light" style={{ fontSize: "14px" }}>
              Tidak ada kelas lain pada tingkatan ini.
            </div>
          )}
        </div>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            disabled={saving}
            onClick={onHide}
          >
            Batal
          </button>
          <button
            type="submit"
            className="sims-modal-submit"
            disabled={saving || !kelasTujuan}
          >
            {saving ? (
              <>
                <span className="sims-button-spinner" />
                Menyimpan...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faFloppyDisk} />
                Simpan
              </>
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
}
